import { render } from "./BarcodeFieldContainer.vue?vue&type=template&id=2626aae9"
import script from "./BarcodeFieldContainer.vue?vue&type=script&lang=js"
export * from "./BarcodeFieldContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__